<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useResultsV2CardsStore } from "@stores/survey/resultsV2/resultsV2.cards";
import { Input } from "@/components/ui/input";
import type { ResultsCard } from "@/types";

const props = defineProps({
  card: { type: Object as PropType<ResultsCard>, required: true },
});

const cardsStore = useResultsV2CardsStore();

const sectionTitle = computed({
  get: () => String(props.card.content?.title || ""),
  set: (val: string) => {
    cardsStore.updateCardLocal(props.card.id, {
      content: { ...props.card.content, title: val },
    });
  },
});
</script>

<template>
  <Input
    :model-value="sectionTitle"
    placeholder="Section title..."
    aria-label="Section title"
    @update:model-value="sectionTitle = String($event)" />
</template>
